export const delay = t => v =>
  new Promise(resolve => setTimeout(resolve, t, v))



// WEBPACK FOOTER //
// ./src/types/time.js